var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "mx-auto" },
        [
          _c("VideoScreenRecording", {
            attrs: {
              "canvas-id": "recordScreenAndVideoCanvasGlobalPopup",
              "global-mode": true,
            },
            on: {
              initialized: function ($event) {
                _vm.initialized = $event
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("b-overlay", {
        staticClass: "d-flex justify-content-center align-items-center",
        attrs: {
          id: "globalVideoScreenRecordingOverlay",
          show: !_vm.initialized,
          "no-wrap": "",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }